import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { CONTRIBUTION_LEVELS, PAGE_NAMES } from '@/constants';
import { getContributionLevelFromDrops, getNextContributionLevelFromDrops } from '@/helpers';
import { ContributionLevel, MyLevelDTO } from '@/models';
import { fetchMyLevel } from '@/services';
import ContributionLevelIcon from '@/components/common/contribution-level-icon/ContributionLevelIcon.vue';
import InlineLoader from '@/components/common/loader/inline-loader/InlineLoader.vue';
import LevelRangeDetails from '@/components/pages/profile/level-range-details/LevelRangeDetails.vue';

@Component({
  components: {
    ContributionLevelIcon,
    InlineLoader,
    LevelRangeDetails
  }
})
export default class MyLevel extends Vue {
  private dataFetching = true;
  private data: MyLevelDTO;

  private beeCostumeMap = {
    normal: 'bee',
    trip: 'trip-bee',
    halloween: 'halloween-bee',
    christmas: 'christmas-bee',
    newYear: 'new-year-bee'
  };

  async created(): Promise<void> {
    const { data } = await fetchMyLevel();
    this.data = data;
    this.dataFetching = false;
    this.$store.commit('app/setUserLevel', data);
  }

  get hasLevel(): boolean {
    return this.data.totalEarnedDrops >= CONTRIBUTION_LEVELS.EGG.min;
  }

  get contributionLevel(): ContributionLevel {
    return getContributionLevelFromDrops(this.data.totalEarnedDrops);
  }

  get nextContributionLevel(): ContributionLevel | null {
    return getNextContributionLevelFromDrops(this.data.totalEarnedDrops);
  }

  get beeContainerLeft(): string {
    const beeContainerWidth = 100;
    if (this.nextContributionLevel) {
      const currentLevelMin = this.contributionLevel.min;
      const nextLevelMin = this.nextContributionLevel.min;
      const ratio = (this.data.totalEarnedDrops - currentLevelMin) / (nextLevelMin - currentLevelMin);
      const ranges = [0.7, 0.5, 0];
      const range = ranges.find(r => ratio >= r) || 0.3;
      return `calc(${Math.floor(range * 100)}% - ${beeContainerWidth / 2}px)`;
    }
    return '60%';
  }

  get beeCostume(): string {
    const currentDate = moment(new Date());
    const year = currentDate.year();
    if (currentDate.isBetween(`${year}-01-10`, `${year}-02-28`, undefined, '[]')) {
      return this.beeCostumeMap.newYear;
    }
    if (currentDate.isBetween(`${year}-06-15`, `${year}-07-15`, undefined, '[]')) {
      return this.beeCostumeMap.trip;
    }
    if (currentDate.isBetween(`${year}-10-15`, `${year}-10-30`, undefined, '[]')) {
      return this.beeCostumeMap.halloween;
    }
    if (currentDate.isBetween(`${year}-12-15`, `${year}-12-31`, undefined, '[]')) {
      return this.beeCostumeMap.christmas;
    }
    return this.beeCostumeMap.normal;
  }

  get chartGraphicShown(): boolean {
    return this.beeCostume !== this.beeCostumeMap.normal;
  }

  navigateToWelcomePage(): void {
    this.$router.push({ name: PAGE_NAMES.WELCOME });
  }
}
